module.exports = __webpack_public_path__ + "img/25_32.734577aa.png";